import React from "react";

const Breadcrumb = ({ title }) => {
  return null;
};

export default Breadcrumb;
